export const taskTypeHelper = (taskType) => {
    switch (taskType) {
        case 0:
            return "Inspection";
        case 1:
            return "Servicing";
        case 2:
            return "Refuelling";
        case 3:
            return "Preventive Maintenance";
        case 4:
            return "Deployment";
        case 5:
            return "Reactive Maintenance";
        case 5:
            return "EV Charging";
        default:
            return "";
    }
};
export let regionOptions = [
    // { value: "", label: "All region" },
    { value: "0", label: "Central" },
    { value: "1", label: "East" },
    { value: "2", label: "North" },
    { value: "3", label: "Northeast" },
    { value: "4", label: "West" },
];
export let estateOptions = [
    { value: "", label: "All estate" },
    {
        value: "Bedok Reservoir",
        label: "Bedok Reservoir",
    },
    {
        value: "Braddell",
        label: "Braddell",
    },
    {
        value: "Marina Bay",
        label: "Marina Bay",
    },
    {
        value: "Raffles Place",
        label: "Raffles Place",
    },
    {
        value: "Chinatown",
        label: "Chinatown",
    },
    {
        value: "Downtown",
        label: "Downtown",
    },
    {
        value: "Anson",
        label: "Anson",
    },
    {
        value: "Tanjong Pagar",
        label: "Tanjong Pagar",
    },
    {
        value: "Harbourfront",
        label: "Harbourfront",
    },
    {
        value: "Telok Blangah",
        label: "Telok Blangah",
    },
    {
        value: "Pasir Panjang",
        label: "Pasir Panjang",
    },
    {
        value: "Clementi",
        label: "Clementi",
    },
    {
        value: "Dover",
        label: "Dover",
    },
    {
        value: "Queenstown",
        label: "Queenstown",
    },
    {
        value: "Bukit Merah",
        label: "Bukit Merah",
    },
    {
        value: "Tiong Bahru",
        label: "Tiong Bahru",
    },
    {
        value: "Beach Road",
        label: "Beach Road",
    },
    {
        value: "Bugis",
        label: "Bugis",
    },
    {
        value: "Golden Mile",
        label: "Golden Mile",
    },
    {
        value: "Little India",
        label: "Little India",
    },
    {
        value: "Orchard",
        label: "Orchard",
    },
    {
        value: "Tanglin",
        label: "Tanglin",
    },
    {
        value: "Bukit Timah",
        label: "Bukit Timah",
    },
    {
        value: "Holland",
        label: "Holland",
    },
    {
        value: "Novena",
        label: "Novena",
    },
    {
        value: "Thomson",
        label: "Thomson",
    },
    {
        value: "Watten Estate",
        label: "Watten Estate",
    },
    {
        value: "Toa Payoh",
        label: "Toa Payoh",
    },
    {
        value: "Balestier",
        label: "Balestier",
    },
    {
        value: "Kallang",
        label: "Kallang",
    },
    {
        value: "Aljunied",
        label: "Aljunied",
    },
    {
        value: "Potong Pasir",
        label: "Potong Pasir",
    },
    {
        value: "Macpherson",
        label: "Macpherson",
    },
    {
        value: "Bidadari",
        label: "Bidadari",
    },
    {
        value: "Geylang",
        label: "Geylang",
    },
    {
        value: "Stadium",
        label: "Stadium",
    },
    {
        value: "Eunos",
        label: "Eunos",
    },
    {
        value: "Paya Lebar",
        label: "Paya Lebar",
    },
    {
        value: "Joo Chiat",
        label: "Joo Chiat",
    },
    {
        value: "Katong",
        label: "Katong",
    },
    {
        value: "Marine Parade",
        label: "Marine Parade",
    },
    {
        value: "East Coast",
        label: "East Coast",
    },
    {
        value: "Bedok",
        label: "Bedok",
    },
    {
        value: "Upper East Coast",
        label: "Upper East Coast",
    },
    {
        value: "Loyang",
        label: "Loyang",
    },
    {
        value: "Pasir Ris",
        label: "Pasir Ris",
    },
    {
        value: "Tampines",
        label: "Tampines",
    },
    {
        value: "Hougang",
        label: "Hougang",
    },
    {
        value: "Sengkang",
        label: "Sengkang",
    },
    {
        value: "Serangoon",
        label: "Serangoon",
    },
    {
        value: "Ang Mo Kio",
        label: "Ang Mo Kio",
    },
    {
        value: "Bishan",
        label: "Bishan",
    },
    {
        value: "Upper Bukit Timah",
        label: "Upper Bukit Timah",
    },
    {
        value: "Jurong East",
        label: "Jurong East",
    },
    {
        value: "Boon Lay",
        label: "Boon Lay",
    },
    {
        value: "Pioneer",
        label: "Pioneer",
    },
    {
        value: "Tuas",
        label: "Tuas",
    },
    {
        value: "Jurong West",
        label: "Jurong West",
    },
    {
        value: "Bukit Batok",
        label: "Bukit Batok",
    },
    {
        value: "Hillview",
        label: "Hillview",
    },
    {
        value: "Bukit Panjang",
        label: "Bukit Panjang",
    },
    {
        value: "CCK",
        label: "CCK",
    },
    {
        value: "Western Water Catchment",
        label: "Western Water Catchment",
    },
    {
        value: "Tengah",
        label: "Tengah",
    },
    {
        value: "Lim Chu Kang",
        label: "Lim Chu Kang",
    },
    {
        value: "Kranji",
        label: "Kranji",
    },
    {
        value: "Woodlands",
        label: "Woodlands",
    },
    {
        value: "Mandai",
        label: "Mandai",
    },
    {
        value: "Sembawang",
        label: "Sembawang",
    },
    {
        value: "Yishun",
        label: "Yishun",
    },
    {
        value: "Upper Thomson",
        label: "Upper Thomson",
    },
    {
        value: "Thompson",
        label: "Thompson",
    },
    {
        value: "Seletar",
        label: "Seletar",
    },
    {
        value: "Changi",
        label: "Changi",
    },
    {
        value: "Punggol",
        label: "Punggol",
    },
];
export let jobOptions = [
    { value: "", label: "All job type" },
    { value: "0", label: "Inspection" },
    { value: "1", label: "Servicing" },
    { value: "2", label: "Refuelling" },
    { value: "3", label: "Preventive Maintenance" },
    { value: "4", label: "Deployment" },
    { value: "5", label: "Reactive Maintenance" },
    { value: "6", label: "EV Charging" },
];
export let priceGroupOptions = [
    {
        value: "53d51e7b-fdd6-4da2-9d7f-69cb75eca0ab",
        label: "BE Test",
        name: "priceGroup",
    },
    {
        value: "8d994e76-91a6-4a50-8552-2ec0b00aec4e",
        label: "negative1",
        name: "priceGroup",
    },
    {
        value: "433f9dbc-4186-49ff-bb5d-ddade6900f4e",
        label: "negative2",
        name: "priceGroup",
    },
    {
        value: "bcd766ab-8eac-4e79-b13e-31c685810e67",
        label: "new test",
        name: "priceGroup",
    },
    {
        value: "67bc3920-95a1-4445-a6ec-12fe4d2be495",
        label: "Patience Dicki",
        name: "priceGroup",
    },
    {
        value: "ca62c0f8-5dde-438a-bfad-bbcc843a2a9a",
        label: "Patience Dickii",
        name: "priceGroup",
    },
    {
        value: "455581ac-7b32-4f0a-b36c-b768f8adadba",
        label: "Patience Dickiii",
        name: "priceGroup",
    },
    {
        value: "94772b0d-fb86-4306-8e9f-8070d3176ccc",
        label: "Patience Dickiiii",
        name: "priceGroup",
    },
    {
        value: "4d65ecc2-512c-4285-b63b-9b739a8f05cb",
        label: "Shawn Powlowski",
        name: "priceGroup",
    },
    {
        value: "74807b64-f700-499a-bae9-daded7b3da70",
        label: "Tier 1 - Standard",
        name: "priceGroup",
    },
];
export let carMakeOptions = [
    { value: "", label: "All Makes" },
    { value: "4b6f20ed-4d7d-4d0b-98e4-901778c1a5ec", label: "BYD" },
    { value: "5d90ff2a-942c-4eca-89b8-dcfb1df27a9d", label: "Fordy" },
    { value: "e857e7aa-46ba-4abe-a2af-cfb259316a58", label: "Honda" },
    { value: "bb25f4b0-588c-4eb7-89af-733894eb65cb", label: "Hyundai" },
    { value: "940ea04b-eeb2-4abf-aed0-9d14167b369c", label: "Kia" },
    { value: "58b6a2bd-3cf0-4d1f-bd99-5b2451870c63", label: "Mazda" },
    { value: "7696885b-6194-4b6f-905b-604c7ac8c97b", label: "Mitsubishi" },
    { value: "994d5a26-c2cc-42b5-b328-7bf36a3c1c88", label: "Nissan" },
    { value: "b8f4c47f-0063-42bb-9635-8e8f9c04505e", label: "Renault" },
    { value: "b3f6c63f-f892-4c01-9906-9776ae916d23", label: "SSangyong" },
    { value: "20953edc-528b-49bf-a18c-0770fb843838", label: "Toyota" },
    { value: "2033209d-da9f-486c-8426-1da65a9a78f2", label: "TSLA" },
    { value: "c77cb9d3-6ada-43c4-9f06-7e08564a4e08", label: "tyty" },
];
export let carModelOptions = [
    { value: "", label: "All Models", make_id: "", type_id: "" },
    {
        value: "c0f333a1-a5a2-4e08-b97e-41fa990291a9",
        label: "3",
        make_id: "58b6a2bd-3cf0-4d1f-bd99-5b2451870c63",
        type_id: "451a46b6-794a-45e5-a3d6-f27bc316a756",
    },
    {
        value: "8b8c7486-96c5-4ff2-bf40-21f6d4d88881",
        label: "Attrage",
        make_id: "7696885b-6194-4b6f-905b-604c7ac8c97b",
        type_id: "451a46b6-794a-45e5-a3d6-f27bc316a756",
    },
    {
        value: "c7135d60-10f9-46a8-a770-500770050c87",
        label: "Avante",
        make_id: "bb25f4b0-588c-4eb7-89af-733894eb65cb",
        type_id: "451a46b6-794a-45e5-a3d6-f27bc316a756",
    },
    {
        value: "f42186b6-735d-4e06-acdf-f540fe1e9ffd",
        label: "Civic",
        make_id: "e857e7aa-46ba-4abe-a2af-cfb259316a58",
        type_id: "451a46b6-794a-45e5-a3d6-f27bc316a756",
    },
    {
        value: "b17c7cdf-db19-4125-9cce-500aeb94ee1d",
        label: "Kona",
        make_id: "bb25f4b0-588c-4eb7-89af-733894eb65cb",
        type_id: "f96222e9-3914-4325-b553-e03446688fbd",
    },
    {
        value: "6740b3cb-f5bc-4c5d-ad15-2575a3d2141d",
        label: "QashQai",
        make_id: "994d5a26-c2cc-42b5-b328-7bf36a3c1c88",
        type_id: "f96222e9-3914-4325-b553-e03446688fbd",
    },
    {
        value: "17e29dc7-9995-4f0c-a11d-fe296f933973",
        label: "Scenic",
        make_id: "b8f4c47f-0063-42bb-9635-8e8f9c04505e",
        type_id: "c6eb03f4-d4cb-4f2e-8780-44e011ad370b",
    },
    {
        value: "0910fa4c-a37f-43d9-8a25-0e70dbe17d4a",
        label: "Shuttle Hybrid",
        make_id: "e857e7aa-46ba-4abe-a2af-cfb259316a58",
        type_id: "65c79d99-f916-492d-ba4b-b40d4a17ef96",
    },
    {
        value: "69160d5d-19ef-4fa4-a6c9-004e49bc5b25",
        label: "Sienta",
        make_id: "20953edc-528b-49bf-a18c-0770fb843838",
        type_id: "c6eb03f4-d4cb-4f2e-8780-44e011ad370b",
    },
    {
        value: "81b2a3c4-fb4e-46df-8d7c-608355ec7eae",
        label: "Sienta Hybrid",
        make_id: "20953edc-528b-49bf-a18c-0770fb843838",
        type_id: "c6eb03f4-d4cb-4f2e-8780-44e011ad370b",
    },
    {
        value: "9bcaa687-a23d-4bd5-8971-0dbb2a322007",
        label: "Stavic",
        make_id: "b3f6c63f-f892-4c01-9906-9776ae916d23",
        type_id: "c6eb03f4-d4cb-4f2e-8780-44e011ad370b",
    },
    {
        value: "0d610a32-4af1-4544-8c43-ee63973212cb",
        label: "Sylphy",
        make_id: "994d5a26-c2cc-42b5-b328-7bf36a3c1c88",
        type_id: "451a46b6-794a-45e5-a3d6-f27bc316a756",
    },
    {
        value: "7a13bd00-9736-458b-91c2-a8304fe6e05c",
        label: "T3",
        make_id: "4b6f20ed-4d7d-4d0b-98e4-901778c1a5ec",
        type_id: "182cec43-6750-4de4-9ebf-a82b00f99295",
    },
    {
        value: "d9ac9d81-df21-40e7-953b-4f2a9c80de88",
        label: "Tivoli",
        make_id: "b3f6c63f-f892-4c01-9906-9776ae916d23",
        type_id: "c6eb03f4-d4cb-4f2e-8780-44e011ad370b",
    },
    {
        value: "2b053912-c8b1-4d77-91de-1f9773b899f9",
        label: "trtrtrt",
        make_id: "e857e7aa-46ba-4abe-a2af-cfb259316a58",
        type_id: "c6eb03f4-d4cb-4f2e-8780-44e011ad370b",
    },
    {
        value: "0b6b2767-d5f1-437c-99a2-354b9b374f78",
        label: "Vezel",
        make_id: "e857e7aa-46ba-4abe-a2af-cfb259316a58",
        type_id: "f96222e9-3914-4325-b553-e03446688fbd",
    },
    {
        value: "3f4824f1-4533-4228-a0ef-bdc349178589",
        label: "Vezel Hybrid",
        make_id: "e857e7aa-46ba-4abe-a2af-cfb259316a58",
        type_id: "f96222e9-3914-4325-b553-e03446688fbd",
    },
    {
        value: "888c2332-70ac-4665-adeb-91589c66f2e8",
        label: "VIOS",
        make_id: "20953edc-528b-49bf-a18c-0770fb843838",
        type_id: "451a46b6-794a-45e5-a3d6-f27bc316a756",
    },
];
export let carSeatOptions = [
    { value: "", label: "Select Seats" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
    { value: 6, label: "6" },
    { value: 7, label: "7" },
    { value: 8, label: "8" },
    { value: 9, label: "9" },
];
export let vehicleColors = [
    { id: "", name: "Select car color.." },
    { id: "50994378-686a-4a7e-bb8d-63007e013aa8", name: "Blacky" },
    { id: "b4efa4ca-2f0a-44aa-9633-8d838cb33ea5", name: "Blue" },
    { id: "2dbc2164-1c46-4e98-849a-c5be780b9912", name: "Brown" },
    { id: "d41da0c3-2032-4bfa-a33d-fef286d74b1f", name: "Green" },
    { id: "bf658b69-85b1-4d1c-bb45-debae06591af", name: "Grey" },
    { id: "2322961d-1dd2-462c-85bf-3617353f5ac3", name: "Indigo" },
    { id: "d88f4079-5761-4948-860a-6a18b393d2a3", name: "Light" },
    { id: "d75c7a43-4c75-4a25-ad89-0c91f73731fe", name: "Purple" },
    { id: "6c235092-5c61-456e-b0f1-d162bcbd17f8", name: "Red" },
    { id: "6d02ac60-9f1f-4f97-95b7-f82c7fcea6b1", name: "sdsd" },
    { id: "045f60b9-7ae5-44e0-aeff-aad00c845295", name: "Silver" },
    { id: "7f5b347e-b44e-48c9-8f6b-60c84bc2df2a", name: "Teal" },
    { id: "226bbbce-ec2e-4fec-93a2-4dac9e962f17", name: "Tint" },
    { id: "768a61f5-dd58-49a2-a7fb-3432e75d063f", name: "Violet" },
    { id: "8c8578b0-b298-4589-954f-7f9d0a1c80de", name: "White" },
    { id: "4c932f0b-a043-41b9-a1f9-cd78dd2ed622", name: "Yellow" },
];
export let carTypeOptions = [
    { value: "", label: "Select type.." },
    { value: "ac302b47-fc0a-4c26-a9a2-bd44276ec92f", label: "Hatchback" },
    { value: "c6eb03f4-d4cb-4f2e-8780-44e011ad370b", label: "MPV" },
    { value: "451a46b6-794a-45e5-a3d6-f27bc316a756", label: "Sedan" },
    { value: "65c79d99-f916-492d-ba4b-b40d4a17ef96", label: "Stationwagon" },
    { value: "f96222e9-3914-4325-b553-e03446688fbd", label: "SUV" },
    { value: "0cdf68ed-922a-41cf-8b74-80bee4a82191", label: "tytyy" },
    { value: "182cec43-6750-4de4-9ebf-a82b00f99295", label: "Van" },
];
export let carStatusOptions = [
    { value: "", label: "All Status" },
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" }
];
export let reportStatusOptions = [
    { value: "", label: "All Status" },
    { value: "0", label: "Pending Review" },
    { value: "1", label: "Rejected" },
    { value: "2", label: "Accepted" },
    { value: "3", label: "Approved" },
];
export let carparkStatusOptions = [
    { value: "", label: "All Status" },
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
];
export let carparkOptions = [
    { value: "", label: "All Carpark" },
    { value: "8a5edb7a-d5c2-4f6d-a243-56ac006f334d", label: "1" },
    { value: "4fbe0b32-081c-46f7-a509-4f813f9f1d0a", label: "123" },
    { value: "c8080b02-76a5-4dcd-906b-e1087d5b9173", label: "A123098" },
    { value: "7c9bcb86-d035-4cc6-b4c8-a8050c0567a3", label: "A123099" },
    { value: "d4e7fe24-593b-4d41-a63b-4424aed37748", label: "A1230999" },
    { value: "960177d0-1432-4dc2-b139-e4b42e152765", label: "B12" },
    { value: "c92393a8-2d54-49b9-8d7a-9d7e5b791d78", label: "B13" },
    { value: "f9cdf870-5c70-432a-8419-067e9e8d6adb", label: "B21" },
    { value: "ab6ddd20-20ec-41b8-9d20-916b9929be34", label: "BE CarPark" },
    { value: "ee6ce99b-0a67-497a-ac11-e4d10765c0bd", label: "BE Carpark 2" },
    { value: "ec63400a-2663-4470-be67-8c3b4eae0600", label: "BJ25" },
    { value: "224e1ec3-4e54-40cb-a5e2-7507ee2f1c95", label: "BL23" },
    { value: "e78fd35a-5dc8-4a9d-aceb-0ac778db9ea8", label: "BLD31" },
    { value: "d7aa6ed4-308a-4307-95d6-13c472f0e703", label: "Burghley" },
    { value: "5f4893c6-935a-4599-b845-749717d04f62", label: "C28M" },
    { value: "c0a2f30c-04e1-4786-9365-a95e69fc6b4d", label: "CCOM" },
    { value: "00584a40-ac19-4d22-8241-2173c624a384", label: "CDG1" },
    { value: "575240ce-eee8-474a-acc9-f4a23f86d663", label: "CITYPLAZA" },
    { value: "b630d281-150e-44b2-84ca-5877ddbbee4d", label: "CK3A" },
    { value: "937d2223-75c2-469d-84a9-4f1a2e0a6a71", label: "CK74" },
    { value: "f45807f4-fdb4-4ac0-bf47-c2967542691f", label: "CK75" },
    { value: "3157fa21-b2ad-490c-8588-219f079a14aa", label: "CTM150" },
    { value: "0f28d0a5-070e-4991-b7f0-fba5c37340d4", label: "EC4" },
    { value: "438b0fd1-16ce-4c07-99da-f46b4c61618f", label: "GMT589" },
    { value: "2b37d2d6-495d-48ac-b084-28939d461b2c", label: "H0015" },
    { value: "4ac6526a-58e4-4ff1-af6f-8c592a93d259", label: "HG1A" },
    { value: "f5628d81-7738-4245-b219-1187ddc08784", label: "HG1C" },
    { value: "edc7374b-15e7-46b1-a03a-e6b5711c4bba", label: "HPB" },
    { value: "c1657a13-baf7-41e5-880d-d62209d8b878", label: "J69M" },
    { value: "0b38d2b5-d077-47ca-a5e2-6cacaaaa9c0d", label: "KT03" },
    { value: "fcc5120b-67a8-4ad7-bef2-0bb626e195dd", label: "LHNBLT" },
    { value: "45a0f0d4-078f-49b4-b2c2-c062b4bbec88", label: "LHNDEPOT" },
    { value: "f5d1fca8-f5e9-4f6a-ba2f-ca2defaf299b", label: "LYF" },
    { value: "fc8318f5-a656-4ffc-9b2a-be71791153e0", label: "MACPM" },
    { value: "7655239f-e9d6-42d5-acb8-f7fcdc693a39", label: "MATTAR" },
    { value: "936fd294-17df-4241-bbc8-789627858ed9", label: "MBCC" },
    { value: "3b298daf-4b10-4e1a-93b1-64e6bce02143", label: "MLK" },
    { value: "362b5520-2efe-4113-88c9-48aaca58bf01", label: "MP4M." },
    { value: "7ccd0020-47a8-41a7-8b60-eff36793f36f", label: "MP6" },
    { value: "18489d8c-1b6c-4c49-aa15-a24736126c90", label: "NAF656" },
    { value: "845c03e2-0b19-4bd3-a290-17c5f844c14e", label: "NIRLHN" },
    { value: "51344899-1dd4-45ad-b87e-92e6c262df65", label: "NOVO418" },
    { value: "c07567f8-7e3e-4a9f-bc78-cacd9d9eb222", label: "NT1" },
    { value: "9e4be8b6-ca4e-42a3-b40c-ba49b3b09cfc", label: "NT3" },
    { value: "d5e3b3ee-499c-4452-ab4b-9561c8937adc", label: "PGLHN" },
    { value: "54b63941-24ab-49d6-85f9-1931fe1a0409", label: "PL27" },
    { value: "8f46f4e7-facf-477d-8dc0-a34c287a02a4", label: "PL51" },
    { value: "f5ca661d-34c1-44cf-b976-8e0a325dce51", label: "PL55" },
    { value: "a49649e8-52cc-4fa3-8c43-b4d908903386", label: "PL57" },
    { value: "c619e6b4-44a7-4b51-915e-5d1fe0ef3529", label: "PL60" },
    { value: "03240f97-d4e7-4bd4-b0d9-f6e484db5d16", label: "PL63" },
    { value: "981c3adc-2e8a-4355-b3e3-6f80a02c1f13", label: "PL67" },
    { value: "52b606c8-bd9f-450d-8728-23ee2bfa4bf9", label: "PL69" },
    { value: "401a3ebb-77df-485a-b71b-3ab2cb0485ff", label: "PL70" },
    { value: "24a2937c-cc41-478a-8ce9-488399abceba", label: "PL71" },
    { value: "f8fae210-12b1-485e-b333-c7270603d907", label: "PL72" },
    { value: "d24fd5a8-b59d-4b35-9ec5-1ec7235c0410", label: "PM14" },
    { value: "3242a4a1-b41c-46bb-92fa-6592a395484b", label: "PM29" },
    { value: "2ffc033d-59b3-40b6-8c68-cfe4df8570ee", label: "PM32" },
    { value: "c0956ab4-e4e9-4ca6-a92b-16e02a5e042f", label: "PP980" },
    { value: "de2be1e0-c02b-4f3c-b35d-c1c9dc1a3578", label: "PR3" },
    { value: "9866ae88-8987-4937-85bc-f2320d4625ec", label: "PSA418" },
    { value: "4caa9b95-e12c-4576-88a0-67790081102d", label: "S0049" },
    { value: "a28fbf16-4d9b-47b4-8b58-642ec731305d", label: "S0166" },
    { value: "dbeff50e-fda2-4999-a421-f93dff05f0d1", label: "S100" },
    { value: "76ad9846-0d85-4fe1-8fb9-418731af6f40", label: "S102" },
    { value: "94f81615-4ff5-4d5f-af8a-8af45da8cb7a", label: "S105" },
    { value: "ece0e5bf-a5e8-4c69-a55b-12ccc4a45096", label: "SB37" },
    { value: "7aa1cb9f-ed68-4bbb-b0bb-1a6330ff386a", label: "SB38" },
    { value: "c2c5fbce-da67-469b-bb76-aa1cd731adcd", label: "SB45" },
    { value: "91ce7b49-8f27-4ad8-a9a2-317bcbb20fc6", label: "SHB570" },
    { value: "d7daa9a5-cc95-4bf6-ad85-6cad1dd67796", label: "SI1" },
    { value: "73ecb1e2-db30-4f66-9c0e-b45c091ed6d5", label: "SK90" },
    { value: "6b374e8c-fc85-4b35-8b63-62d8aca1d428", label: "SK92" },
    { value: "9ee37d5b-bab4-4417-a13f-fae20655f37e", label: "SK94" },
    { value: "fb3be116-b1a9-4ee8-8750-ad1fd89fe843", label: "SK95" },
    { value: "d9ae9cde-edcc-40f4-a240-0399345775fa", label: "SK98" },
    { value: "b841c39d-fc66-434e-996b-08d084d87e0d", label: "SK99" },
    { value: "45fd2360-4c6f-49fe-a8c8-6bcbb1196abd", label: "T19" },
    { value: "5a17eed7-4e3f-4408-a92b-1a6bf7a3e83f", label: "T32" },
    { value: "b4e3ff2a-683c-4712-9e87-17717867b688", label: "TEST123" },
    { value: "67261d71-0b6b-40a7-91fd-4a28b699febb", label: "TGM2" },
    { value: "6d210e4a-7cd8-452e-9dbb-a98703c58166", label: "THK" },
    { value: "e8883bca-8a73-4c31-8940-6b7aecd9b115", label: "TIC" },
    { value: "cb7abf50-0af6-4762-8554-47f8f99864b0", label: "TJ28" },
    { value: "3242f7b8-2c83-4d63-b76c-7a8e7768b909", label: "TJ38" },
    { value: "9429690d-c7bb-4f09-a887-abca6e634058", label: "TM46" },
    { value: "1e68d7b5-c78a-4bcc-8280-61f817861c66", label: "TM50" },
    { value: "af7cdf0b-56ff-411c-b4dd-a24baa8b8dff", label: "TPMA" },
    { value: "69657107-f880-48df-b45c-114fdbc2eb5e", label: "TPMF" },
    { value: "4e4f31fd-4643-4112-a127-ef446833975e", label: "TPMN" },
    { value: "49d7b531-4ecf-48c1-aa2f-f5137c3bfd17", label: "TPW5" },
    { value: "731eaf7d-f735-469e-8da0-b1e4a7bdc90f", label: "TSLHN" },
    { value: "1a346c4d-e028-4650-be6a-923422907c46", label: "U3" },
    { value: "19df486b-5245-4d84-9cb7-563868914e36", label: "U46" },
    { value: "d3eb15e4-c2c9-459a-b33f-ac189a9798e0", label: "U56" },
    { value: "ae7a8373-7e60-45f0-9610-dcc5af90b623", label: "U58" },
    { value: "5b338520-901f-473f-bbe4-4c7115ae157d", label: "U59" },
    { value: "c8e0ec71-c168-4141-819c-f365abe5c0c4", label: "U65" },
    { value: "8b05ab00-c083-48f6-8f0d-393cf320cd5f", label: "U7" },
    { value: "06e0ab18-1ddd-405c-bf30-60ea7993d899", label: "UBTR794" },
    { value: "d254a927-68ad-4b45-9cfc-d5b9bf5a370e", label: "W182" },
    { value: "f0c3f4c5-cc51-437b-b777-63341eab3699", label: "W579" },
    { value: "147c9d3b-2390-45df-8b81-cdcf213dcdb6", label: "W785" },
    { value: "08480563-fc63-490e-a8d6-c50779d78450", label: "W887" },
    { value: "8f064412-caf8-46d8-adbf-b7fa19eff663", label: "WAVE9S" },
    { value: "adb79a05-34d1-4c25-b88b-ed0313e9a632", label: "WBH" },
    { value: "13bd889b-5d61-4dfb-843b-2f697b3bd631", label: "WestWay" },
    { value: "f91d75c2-8d6a-4b50-b270-4a77782d8b47", label: "WS511" },
    { value: "33fb7220-592a-4a94-a871-8781cf39f540", label: "Y28M" },
    { value: "1b06d0af-ea99-44af-b4e4-31792a92d6c0", label: "Y63M" },
    { value: "9ba5cdae-17f9-4343-b5bc-11682a31cac2", label: "Y66M" },
    { value: "61449642-4d22-407e-a125-74ce34ca345a", label: "Y68M" },
    { value: "407ee451-6ce7-4b5b-be79-d85ff58376b2", label: "Y70M" },
    { value: "d4a00e7b-ff50-4ce2-86bb-d2147a702259", label: "Y74M" },
    { value: "5202fab6-3204-4906-b223-f376c296b9fd", label: "Y9" },
    { value: "7f5f9bfe-01d0-4ef2-adf3-7afab008a7a2", label: "YWCA" },
];
export let carAssetOwners = [
    { value: "", label: "Select car asset owners" },
    { value: "912bcc2b-9b6a-4531-84df-7ff43b150640", label: "'j" },
    { value: "405a9ed1-a799-42cc-b83d-a3bf9af82697", label: "Asset Owner BE" },
    {
        value: "42a62b95-38a3-483e-a1aa-f5c72b056af9",
        label: "GetGo Technologies Pte Ltd",
    },
    {
        value: "b4653341-2e01-4114-aff1-3591d120fcbf",
        label: "Lion City Rentals",
    },
    { value: "7fe6f43d-1a43-41d1-b0c6-fefb95ce2541", label: "Motorway Group" },
];
export let carParkOwners;
export let userStatusOptions = [
    { value: "", label: "All Status" },
    { value: "0", label: "Active" },
    { value: "1", label: "Inactive" },
    // { value: "2", label: "Suspended" },
    { value: "3", label: "Pending" },
];
export let fmsUserStatusOptions = [
    { value: "", label: "All Status" },
    { value: "true", label: "Active" },
    { value: "false", label: "Inactive" },
];
export let groupStatusOptions = [
    { value: "", label: "All Status" },
    { value: "0", label: "Active" },
    { value: "1", label: "Inactive" },
    // { value: "2", label: "Suspended" },
    // { value: "3", label: "Pending" },
];
export let jobStatusOptions = [
    {
        value: "",
        label: "All status",
    },
    {
        value: "0",
        label: "Open",
    },
    {
        value: "1",
        label: "Taken",
    },
    {
        value: "6",
        label: "Ongoing",
    },
    {
        value: "7",
        label: "Paused",
    },
    // {
    // 	value: "2",
    // 	label: "Complete",
    // },
    // {
    // 	value: "3",
    // 	label: "Incomplete",
    // },
    // {
    // 	value: "4",
    // 	label: "Deleted",
    // },
];
export let taskTypeOptions = [
    { value: "", label: "All task type" },
    { value: "0", label: "Inspection" },
    { value: "1", label: "Cleaning" },
    { value: "2", label: "Refuelling" },
    { value: "3", label: "Fixing" },
    { value: "4", label: "Deployment" },
    { value: "5", label: "Sending to workshop" },
];
export let fuelTypeOptions = [
    // {
    // 	name: "fuelType",
    // 	value: undefined,
    // 	label: "None",
    // },
    // {
    // 	name: "fuelType",
    // 	value: "",
    // 	label: "All fuel type",
    // },
    {
        name: "fuelType",
        value: "9a40035e-3688-44e5-bc71-fb6a62fb8f68",
        label: "Diesel",
    },
    {
        name: "fuelType",
        value: "5cce47b8-e71c-48d9-8b1d-7c3cd8610b3f",
        label: "Electric",
    },
    {
        name: "fuelType",
        value: "bd8cf991-e9f1-4b72-8916-a73f7a9b857d",
        label: "LPG",
    },
    {
        name: "fuelType",
        value: "36d23b56-802c-4736-8434-d8f8193250c0",
        label: "Petrol",
    },
];
export let damageAreaOptions = [
    {
        name: "damageArea",
        value: "Front",
        label: "Front",
    },
    {
        name: "damageArea",
        value: "Driver side",
        label: "Driver side",
    },
    {
        name: "damageArea",
        value: "Passenger side",
        label: "Passenger side",
    },
    {
        name: "damageArea",
        value: "Back",
        label: "Back",
    },
];
export let carSectionOptions = [
    {
        name: "damageArea",
        value: "",
        label: "All Damage Area",
    },
    {
        name: "damageArea",
        value: "Front",
        label: "Front",
    },
    {
        name: "damageArea",
        value: "Driver side",
        label: "Driver side",
    },
    {
        name: "damageArea",
        value: "Passenger side",
        label: "Passenger side",
    },
    {
        name: "damageArea",
        value: "Back",
        label: "Back",
    },
];
export let damageTypeOptions = [
    {
        name: "damageType",
        value: "Dent",
        label: "Dent",
    },
    {
        name: "damageType",
        value: "Crack",
        label: "Crack",
    },
    {
        name: "damageType",
        value: "Scratch",
        label: "Scratch",
    },
    {
        name: "damageType",
        value: "Missing",
        label: "Missing",
    },
    {
        name: "damageType",
        value: "Misalign",
        label: "Misalign",
    },
    {
        name: "damageType",
        value: "Broken",
        label: "Broken",
    },
    {
        name: "damageType",
        value: "Tyre",
        label: "Tyre",
    },
    {
        name: "damageType",
        value: "Others",
        label: "Others",
    },
];
export let damageTypeOptionsSelect = [
    {
        name: "damageType",
        value: "",
        label: "All Damage Type",
    },
    {
        name: "damageType",
        value: "Dent",
        label: "Dent",
    },
    {
        name: "damageType",
        value: "Crack",
        label: "Crack",
    },
    {
        name: "damageType",
        value: "Scratch",
        label: "Scratch",
    },
    {
        name: "damageType",
        value: "Missing",
        label: "Missing",
    },
    {
        name: "damageType",
        value: "Detach",
        label: "Detach",
    },
    {
        name: "damageType",
        value: "Misalign",
        label: "Misalign",
    },
    {
        name: "damageType",
        value: "Broken",
        label: "Broken",
    },
    {
        name: "damageType",
        value: "Tyre",
        label: "Tyre",
    },
    {
        name: "driveDamageType",
        value: "Headlight",
        label: "Headlight",
    },
    {
        name: "driveDamageType",
        value: "Wiper",
        label: "Wiper",
    },
    {
        name: "driveDamageType",
        value: "Dashboard",
        label: "Dashboard",
    },
    {
        name: "driveDamageType",
        value: "Brakes",
        label: "Brakes",
    },
    {
        name: "driveDamageType",
        value: "Others",
        label: "Others",
    },
];
export let damageCategory = [
    {
        name: "damageCategory",
        value: "Exterior",
        label: "Exterior",
    },
    {
        name: "damageCategory",
        value: "Drive",
        label: "Drive",
    },
];
export let reportSectionOptions = [
    {
        name: "damageCategory",
        value: "",
        label: "All Report Section",
    },
    {
        name: "damageCategory",
        value: "Exterior",
        label: "Exterior",
    },
    {
        name: "damageCategory",
        value: "Drive",
        label: "Drive",
    },
];
export let driveDamageTypeOptions = [
    {
        name: "driveDamageType",
        value: "Headlight",
        label: "Headlight",
    },
    {
        name: "driveDamageType",
        value: "Wiper",
        label: "Wiper",
    },
    {
        name: "driveDamageType",
        value: "Dashboard",
        label: "Dashboard",
    },
    {
        name: "driveDamageType",
        value: "Brakes",
        label: "Brakes",
    },
    {
        name: "driveDamageType",
        value: "Others",
        label: "Others",
    },
];
export let showDamagesOptions = [
    {
        name: "showDamages",
        value: "1",
        label: "Yes",
    },
    {
        name: "showDamages",
        value: "0",
        label: "No",
    },
];
export let imageUploadOptions = [
    {
        name: "imageUpload",
        value: "1",
        label: "Yes",
    },
    {
        name: "imageUpload",
        value: "0",
        label: "No",
    },
];
export let drivingLicenceClassOptions = [
    { value: "1", label: "3" },
    { value: "2", label: "3A" },
    { value: "3", label: "3C" },
    { value: "4", label: "3CA" },
    { value: "5", label: "2" },
    { value: "6", label: "2A" },
    { value: "7", label: "2B" },
    { value: "8", label: "4" },
    { value: "9", label: "4A" },
    { value: "10", label: "5" },
    { value: "11", label: "IDP" },
];
export let fuelCompanyOptions = [
    { value: "", label: "All Fuel Companies" },
    { value: "0", label: "Esso Mobil" },
];
export let fuelCompanyIdOptions = [
    { value: "", label: "All Fuel Companies" },
    { value: "4174d953-c44c-4fd3-ad78-addcae12f37d", label: "Esso Mobil" },
];
//For Vehicle Issues
export let VehicleCarSectionOptions = [
    {
        name: "damageArea",
        value: "0",
        label: "NA",
    },
    {
        name: "damageArea",
        value: "1",
        label: "Front",
    },
    {
        name: "damageArea",
        value: "2",
        label: "Driver side",
    },
    {
        name: "damageArea",
        value: "3",
        label: "Passenger side",
    },
    {
        name: "damageArea",
        value: "4",
        label: "Back",
    },
    {
        name: "damageArea",
        value: "5",
        label: "Rear",
    },
];
//For Vehicle Issues
export let VehicleReportSectionOptions = [
    {
        name: "damageCategory",
        value: "0",
        label: "Not Applicable",
    },
    {
        name: "damageCategory",
        value: "1",
        label: "Drive",
    },
    {
        name: "damageCategory",
        value: "2",
        label: "Cleanliness",
    },
    {
        name: "damageCategory",
        value: "3",
        label: "Exterior",
    },
];
//For Vehicle Issues
export let VehicleDamageTypeOptions = [
    {
        name: "damageType",
        value: "3",
        label: "Dent",
    },
    {
        name: "damageType",
        value: "2",
        label: "Crack",
    },
    {
        name: "damageType",
        value: "1",
        label: "Scratch",
    },
    {
        name: "damageType",
        value: "4",
        label: "Missing",
    },
    {
        name: "damageType",
        value: "5",
        label: "Detach",
    },
    {
        name: "damageType",
        value: "6",
        label: "Others",
    },
];
export let cmmDamageTypeOptions = [
    {
        name: "damageType",
        label: "NA",
    },
    {
        name: "damageType",
        label: "Scratch",
    },
    {
        name: "damageType",
        label: "Crack",
    },
    {
        name: "damageType",
        label: "Dent",
    },
    {
        name: "damageType",
        label: "Missing",
    },
    {
        name: "damageType",
        label: "Detach",
    },
    {
        name: "damageType",
        label: "Broken",
    },
    {
        name: "damageType",
        label: "Misalign",
    },
    {
        name: "damageType",
        label: "Brakes",
    },
    {
        name: "damageType",
        label: "Dashboard",
    },
    {
        name: "damageType",
        label: "Headlight",
    },
    {
        name: "damageType",
        label: "Tyre",
    },
    {
        name: "damageType",
        label: "Wiper",
    },
    {
        name: "damageType",
        label: "Others",
    },
];
export let cmmRejectReasonOptions = [
    {
        name: "rejectReason",
        label: "Irrelevant",
    },
    {
        name: "rejectReason",
        label: "Blur",
    },
    {
        name: "rejectReason",
        label: "Not Billable",
    },
];
export let EVCompanyIdOptions = [
    { value: "", label: "All EV Companies" },
    { value: "1", label: "CDG Engie" },
    // { value: "2", label: "Charge+" },
    // { value: "3", label: "ChargeEco" },
];
export const carDetailValues = [
    { field: "id", required: true },
    { field: "vehicleMakeId", required: true },
    { field: "vehicleMakeName", required: true },
    { field: "vehicleModelId", required: true },
    { field: "vehicleModelName", required: true },
    { field: "vehicleTypeId", required: true },
    { field: "vehicleTypeName", required: true },
    { field: "vehicleFuelId", required: true },
    { field: "fuelTypeName", required: true },
    { field: "vehicleColorId", required: true },
    { field: "vehicleColorName", required: true },
    { field: "description", required: true },
    { field: "plateNumber", required: true },
    { field: "iuNumber", required: true },
    { field: "chassisNumber", required: true },
    { field: "engineNumber", required: true },
    { field: "numSeats", required: true },
    { field: "bootSpace", required: true },
    { field: "carParkId", required: true },
    { field: "carParkName", required: true },
    { field: "carParkAddress", required: true },
    { field: "assetOwnerId", required: true },
    { field: "assetOwnerName", required: true },
    { field: "priceGroupId", required: true },
    { field: "priceGroupName", required: true },
    { field: "lastServiceDate", required: true },
    { field: "lastCleanedDate", required: true },
    { field: "lastServiceMileage", required: true },
    { field: "currentMileage", required: true },
    { field: "currentFuelLevel", required: true },
    { field: "activeFrom", required: true },
    { field: "activeTo", required: true },
    { field: "createdAt", required: true },
    { field: "updatedAt", required: true },
    { field: "status", required: true },
    { field: "vehicleImages", required: true },
    { field: "carParkLots", required: true },
    { field: "fuelCards", required: true },
];
export const carparkDetailValues = [
    { field: "carParkId", required: true },
    { field: "description", required: true },
    { field: "activeTo", required: true },
    { field: "activeFrom", required: true },
    { field: "carParkOwnerId", required: true },
    { field: "longitude", required: false },
    { field: "latitude", required: false },
    { field: "postalCode", required: false },
    { field: "carParkImages", required: false },
    { field: "address", required: true },
    { field: "carParkLots", required: true },
];
export const carParkLotValues = [
    { field: "id", required: true },
    { field: "level", required: true },
];
export const jobTypesEnum = {
    0: "Inspection",
    1: "Servicing",
    2: "Refuelling",
    3: "Preventive Maintenance",
    4: "Deployment",
    5: "Reactive Maintenance",
    6: "EV Charging",
};
export const statusMap = {
    0: '<p class="status-bar status-bar-3">Open</p>',
    1: '<p class="status-bar status-bar-2">Taken</p>',
    2: '<p class="status-bar status-bar-1">Complete</p>',
    3: '<p class="status-bar status-bar-3">Incomplete</p>',
    4: '<p class="status-bar status-bar-3">Deleted</p>',
    5: '<p class="status-bar status-bar-3">Overdue</p>',
    6: '<p class="status-bar status-bar-1">Ongoing</p>',
    7: '<p class="status-bar status-bar-2">Paused</p>',
};
export const statusMapStr = {
    Assigned: `<p class="status-bar status-bar-6">Assigned</p>`,
    Open: '<p class="status-bar status-bar-4">Open</p>',
    Taken: '<p class="status-bar status-bar-2">Taken</p>',
    Complete: '<p class="status-bar status-bar-6">Complete</p>',
    Completed: '<p class="status-bar status-bar-6">Completed</p>',
    Incomplete: '<p class="status-bar status-bar-5">Incomplete</p>',
    Deleted: '<p class="status-bar status-bar-3">Deleted</p>',
    Overdue: '<p class="status-bar status-bar-3">Overdue</p>',
    Ongoing: '<p class="status-bar status-bar-8">Ongoing</p>',
    Paused: '<p class="status-bar status-bar-2">Paused</p>',
    Cancelled: '<p class="status-bar status-bar-7">Cancelled</p>',
    Created: '<p class="status-bar status-bar-4">Created</p>',
};
export const jobStatusFilter = {
    active: [
        { id: "open", name: "Open" },
        { id: "assigned", name: "Assigned" },
        { id: "ongoing", name: "Ongoing" },
        { id: "paused", name: "Paused" },
    ],
    past: [
        { id: "completed", name: "Completed" },
        { id: "incomplete", name: "Incomplete" },
        { id: "cancelled", name: "Cancelled" },
    ],
};
export const servicingStatus = {
    DueSoon: '<p class="status-bar status-bar-2">Due soon</p>',
    Overdue: '<p class="status-bar status-bar-3">Overdue</p>',
};
export const jobStatusEnum = {
    0: "active",
    1: "active",
    2: "completed",
    3: "incomplete",
    4: "deleted",
    5: "overdue",
    6: "active",
    7: "active",
};
export const carStatusMap = {
    0: '<div class="status-bar status-bar-3">Inactive</div>',
    1: '<div class="status-bar status-bar-1">Active</div>',
};
export const priorityOptions = [
    { value: "0", label: "Low" },
    { value: "1", label: "Medium" },
    { value: "2", label: "High" },
];
export const rejectedReasonEnum = [
    { value: 0, label: "No Damage" },
    { value: 2, label: "No New Damage" },
];
export const verdictOptions = {
    newDamage: `<p class="status-bar status-bar-danger">New Damage</p>`,
    noNewDamage: `<p class="status-bar status-bar-black">No New Damage</p>`,
    noDamage: `<p class="status-bar status-bar-gray">No Damage</p>`, // No Damage
};
